import React from "react";
import useHover from "../hooks/useHover";

const PlayerOptions = ({ player, openArea, areaOpen }) => {
  function answerQuestions() {}
  function openPlayerSearch() {}
  function openPlaymatesList() {}
  function openStatements() {}
  function showRules() {}
  const options = [
    { text: "Answer Questions", onClick: answerQuestions },
    { text: "Check in on others", onClick: openPlayerSearch },
    { text: "Playmates", onClick: openPlaymatesList },
    { text: "Statements", onClick: openStatements },
    { text: "Read Rules", onClick: showRules },
    {
      text: "Browse Box Types",
      onClick: openArea,
      image: "/icons/icon_box.png",
      type: "boxTypes",
    },
  ];

  return (
    <div
      className="divColumn"
      style={{ width: "100%", backgroundColor: "#5f5f5f", padding: "5px" }}
    >
      {options.map((o) => (
        <OptionHolder o={o} key={o.text} areaOpen={areaOpen} />
      ))}
    </div>
  );
};

const OptionHolder = ({ o, areaOpen }) => {
  const hover = useHover();
  return (
    <button
      className="divRow"
      {...hover.divProps}
      onClick={o.onClick}
      style={{
        width: "100%",
        padding: "5px",
        backgroundColor: hover.hover
          ? "#4f4f4f"
          : o.type == "boxTypes" && areaOpen
          ? "white"
          : "#7f7f7f",
        color: hover.hover ? "gold" : "white",
        justifyContent: "center",
      }}
    >
      {o.image && (
        <img src={o.image} className="icon20" style={{ marginLeft: "10px" }} />
      )}
      <div
        className="textBoldWhite"
        style={{
          flex: 1,
          color: o.type == "boxTypes" && areaOpen ? "black" : "white",
        }}
      >
        {o.type == "boxTypes" && areaOpen ? "Close Box Types" : o.text}
      </div>
      {o.image && <div style={{ width: "35px" }} />}
    </button>
  );
};

export default PlayerOptions;
